module.exports = __webpack_public_path__ + "static/media/FM.b0689752.png";